import { environment } from "src/environments/environment";

export class chamadoDados {
    assunto: string;
    _categoria: string;
    data_hora_abertura: string;
    descricao: string;
    _prioridade: _priodidadeValue;
    protocolo: string;
    protocolo_orcamento: string;
    status: string;
    nome_empresa: string;
    razao_social: string;
    tipo_empresa: string;
    uuid_gestor: string;
    nome_gestor: string;
    uuid_usuario_abertura: string;
    notificacao: string;
    notificacaoAtiva: boolean;
    public get categoria() {
        return this._categoria;
    }
    public set categoria(value: any) {
        environment.categoriaChamado.forEach((e: any) => {
            if (e.value == value) { this._categoria = e.label; return; };
        });
    }

    public get prioridade() {
        return this._prioridade;
    }
    public set prioridade(value: any) {
        switch (value) {
            case (1): { this._prioridade = 'Alta'; return; };
            case (2): { this._prioridade = 'Media'; return; };
            case (3): { this._prioridade = 'Baixa'; return; };
            default: this._prioridade = 'Não informada';
        }
    }

    public set prioridadeString(value: _priodidadeValue) {
        this._prioridade = value;
    }

    public get prioridadeNumber(): Number {
        switch (this._prioridade) {
            case ('Alta'): { return 1 };
            case ('Media'): { return 2 };
            case ('Baixa'): { return 3 };
            default: { return 3 };
        }
    }

    public map(json: any) {
        this.assunto = json?.assunto;
        this.categoria = json?.categoria;
        this.data_hora_abertura = json?.data_hora_abertura;
        this.descricao = json?.descricao;
        this.nome_empresa = json?.fantasia;
        this.tipo_empresa = json?.tipo;
        this.protocolo = json?.protocolo;
        this.protocolo_orcamento = json?.protocolo_orcamento;
        this.nome_gestor = json?.nome;
        this.uuid_gestor = json?.uuid_gestor;
        this.prioridade = json?.prioridade;
        this.status = json?.status;
        this.notificacao = json?.notificacao;
        this.uuid_usuario_abertura = json?.uuid_usuario_abertura;
        this.razao_social = json?.razao_social;
    }
}

export type _priodidadeValue = 'Alta' | 'Media' | 'Baixa' | 'Não informada';